// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlignmentFormController from "./alignment_form_controller"
application.register("alignment-form", AlignmentFormController)

import AlignmentPreviewController from "./alignment_preview_controller"
application.register("alignment-preview", AlignmentPreviewController)

import AwarenessController from "./awareness_controller"
application.register("awareness", AwarenessController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import CommentFormController from "./comment_form_controller"
application.register("comment-form", CommentFormController)

import CompanySetupController from "./company_setup_controller"
application.register("company-setup", CompanySetupController)

import ConfidenceController from "./confidence_controller"
application.register("confidence", ConfidenceController)

import ConsentController from "./consent_controller"
application.register("consent", ConsentController)

import DashboardNotesController from "./dashboard_notes_controller"
application.register("dashboard-notes", DashboardNotesController)

import DragDropController from "./drag_drop_controller"
application.register("drag-drop", DragDropController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import HotkeyController from "./hotkey_controller"
application.register("hotkey", HotkeyController)

import MentionsController from "./mentions_controller"
application.register("mentions", MentionsController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalDialogController from "./modal_dialog_controller"
application.register("modal-dialog", ModalDialogController)

import NestedListController from "./nested_list_controller"
application.register("nested-list", NestedListController)

import NotesController from "./notes_controller"
application.register("notes", NotesController)

import NotesNavigationController from "./notes_navigation_controller"
application.register("notes-navigation", NotesNavigationController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OkrHighlightController from "./okr_highlight_controller"
application.register("okr-highlight", OkrHighlightController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import PeriodSelectorController from "./period_selector_controller"
application.register("period-selector", PeriodSelectorController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ProgressPopoverController from "./progress_popover_controller"
application.register("progress-popover", ProgressPopoverController)

import ProgressUpdateFormController from "./progress_update_form_controller"
application.register("progress-update-form", ProgressUpdateFormController)

import ReactionController from "./reaction_controller"
application.register("reaction", ReactionController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ResizeController from "./resize_controller"
application.register("resize", ResizeController)

import ResponsiveFormController from "./responsive_form_controller"
application.register("responsive-form", ResponsiveFormController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TeamSelectorController from "./team_selector_controller"
application.register("team-selector", TeamSelectorController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
